import { Leaf } from 'lucide-react';

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
};

export const WelcomeBanner = ({ name, jobsToday, newQuotes }) => (
  <div data-testid="dashboard-welcome-banner" className="relative overflow-hidden rounded-3xl bg-white border border-lime-100 px-6 sm:px-8 py-7 mb-6 shadow-sm">
    <Leaf aria-hidden="true" className="absolute -top-6 right-1/3 w-28 h-28 text-green-600/10 rotate-45" strokeWidth={1.2} />
    <Leaf aria-hidden="true" className="absolute top-6 right-[42%] w-8 h-8 text-lime-600/20 -rotate-12" strokeWidth={1.5} />
    <div className="relative z-10 max-w-xl">
      <p className="text-green-700 text-sm font-medium" data-testid="dashboard-welcome-date">
        {new Date().toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' })}
      </p>
      <h2 className="text-2xl sm:text-3xl font-bold mt-1 text-stone-900" style={{ fontFamily: "'Outfit', sans-serif" }} data-testid="dashboard-welcome-greeting">
        {greeting()}, {name}!
      </h2>
      <p className="text-stone-600 mt-2 text-sm sm:text-base" data-testid="dashboard-welcome-summary">
        You have <span className="font-bold text-stone-900">{jobsToday} {jobsToday === 1 ? 'job' : 'jobs'}</span> today
        {' '}and <span className="font-bold text-stone-900">{newQuotes} new {newQuotes === 1 ? 'quote' : 'quotes'}</span> today.
      </p>
    </div>
  </div>
);
